export { ClozeInput as default };
import React from 'react';
import PropTypes from 'prop-types';
import sanitzeHtml from 'sanitize-html';

import styles from './styles.less';

function ClozeInput(_ref) {
  var _onClick = _ref.onClick,
      id = _ref.id,
      text = _ref.text,
      hasFocus = _ref.hasFocus;

  if (text) {
    return React.createElement('span', {
      role: 'button',
      className: styles.inputText + ' ' + (hasFocus && styles.focus),
      onClick: function onClick() {
        return _onClick(id);
      },
      dangerouslySetInnerHTML: { __html: sanitzeHtml(text) }
    });
  }
  return React.createElement('input', {
    type: 'text',
    className: styles.inputText + ' ' + (hasFocus && styles.focus),
    onClick: function onClick() {
      return _onClick(id);
    },
    value: text,
    style: text ? { width: text.length + 'ch' } : null,
    readOnly: true
  });
}

ClozeInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  hasFocus: PropTypes.bool,
  text: PropTypes.string
} : {};

ClozeInput.defaultProps = {
  hasFocus: false,
  text: ''
};